module.exports = __webpack_public_path__ + "static/media/fortalezas_card_detail.4d410903.png";